import Box from '@mui/material/Box';
import { sp } from '@/theme/mui';
import Stack from '@mui/material/Stack';
import { Card } from '@/components/atoms/Card/Card';
import { PhoneNumberButton } from './PhoneNumberButton';

interface CareEnquiriesCardProps {
  phoneNumber: string;
  providerName?: string;
  email?: string;
  regulatoryId?: string;
}

export const CareEnquiriesCard = ({
  phoneNumber,
  providerName,
  regulatoryId,
}: CareEnquiriesCardProps) => {
  return (
    <Card color='green' isNoPadding>
      <Stack
        sx={{
          gap: sp[20],
          alignItems: 'flex-start',
          p: sp[20],
          borderRadius: sp[16],
        }}
      >
        <Stack sx={{ gap: sp[12] }}>
          <Box
            component='h4'
            sx={{
              typography: 'bodyXlSemibold',
              color: '#404042',
              m: 0,
            }}
          >
            Contact this home
          </Box>
          <Box
            component='p'
            sx={{
              m: 0,
              typography: 'bodyLg',
              color: '#666667',
            }}
          >
            <strong>Call now</strong> for more details - staff are happy to
            answer any of your questions about care.
          </Box>
        </Stack>
        <PhoneNumberButton
          phoneNumber={phoneNumber}
          providerName={providerName}
          regulatoryId={regulatoryId}
        />
      </Stack>
    </Card>
  );
};

export default CareEnquiriesCard;
